import { Box, Grid, Typography } from '@mui/material'
import { useTranslate } from '@tolgee/react'
import { useMinimalsTheme } from '@tom-ui/ui'
import { observer } from 'mobx-react-lite'
import { FC } from 'react'
import { ContainerJourneyCardProps } from './ContainerJourneyCard'
import { ContainerJourneyCardCarrierVisitInfo } from './ContainerJourneyCardCarrierVisitInfo'

export const ContainerJourneyCardBody: FC<ContainerJourneyCardProps> = observer(props => {
  const { inbound, outbound } = props
  const theme = useMinimalsTheme()
  const { t } = useTranslate()

  if (!inbound && !outbound) return <></>

  const order = inbound ?? outbound

  return (
    <Grid container spacing={0}>
      <Grid size={4}>
        <Box sx={{ padding: theme.customSpacing.s, height: '100%' }}>
          <Typography variant='subtitle1'>
            {order?.referenceNumber ? `Ref: ${order?.referenceNumber}` : 'Storage'}
          </Typography>
          <Typography variant='body1'>{order?.customerName}</Typography>
        </Box>
      </Grid>
      <Grid size={4}>
        <Box
          sx={{
            borderLeft: `1px solid ${theme.palette.divider}`,
            display: inbound ? 'flex' : 'block',
            padding: theme.customSpacing.s,
            height: '100%',
          }}
        >
          <Typography variant='subtitle1' mr={theme.customSpacing.m}>
            {t('in', 'In')}
          </Typography>
          <ContainerJourneyCardCarrierVisitInfo direction='Inbound' orderData={inbound} />
        </Box>
      </Grid>

      <Grid size={4}>
        <Box
          sx={{
            borderLeft: `1px solid ${theme.palette.divider}`,
            display: outbound ? 'flex' : 'block',
            height: '100%',
            padding: theme.customSpacing.s,
          }}
        >
          <Typography variant='subtitle1' mr={theme.customSpacing.m}>
            {t('out', 'Out')}
          </Typography>

          <ContainerJourneyCardCarrierVisitInfo direction='Outbound' orderData={outbound} />
        </Box>
      </Grid>
    </Grid>
  )
})
